__turbopack_context__.v({
  "label": "styles-module-scss-module__nfmkmq__label",
  "leadingIcon": "styles-module-scss-module__nfmkmq__leadingIcon",
  "linkButton": "styles-module-scss-module__nfmkmq__linkButton",
  "trailingIcon": "styles-module-scss-module__nfmkmq__trailingIcon",
});
